module.exports = __webpack_public_path__ + "bf716ddbb959d1d6e4e9a192bf05a180.png";